// Register the plugin with Capacitor
import { registerPlugin } from '@capacitor/core';

/**
 * WireGuard VPN Plugin for Capacitor
 * 
 * Available methods:
 * - checkPermissions(): Promise<{ granted: boolean; message?: string }>
 * - requestPermissions(): Promise<{ granted: boolean; message?: string; userDenied?: boolean }>
 * - connect(options: { config: string }): Promise<{ success: boolean; message?: string; permissionRequired?: boolean }>
 * - disconnect(): Promise<{ success: boolean; message?: string }>
 * - getStatus(): Promise<{ connected: boolean; serverName?: string; connectedAt?: string; bytesIn?: number; bytesOut?: number }>
 * - configureAlwaysOn(options: { alwaysOn: boolean; blockWithoutVpn: boolean }): Promise<{ success: boolean; message?: string }>
 * - addListener(eventName: string, listenerFunc: function): Promise<any>
 * - removeAllListeners(): Promise<void>
 */
export const WireGuard = registerPlugin('WireGuard');